import { fosfaatklasses, grondsoorten } from "./settings";

const config = [
  {
    type: "grasland",
    key: "graslandOppervlakte",
    kenmerkenValue: "graslandWaarde",
  },
  {
    type: "natuurgrasland",
    key: "natuurgraslandOppervlakte",
    kenmerkenValue: "natuurgraslandWaarde",
  },
  {
    type: "akkerbouw",
    key: "akkerbouwOppervlakte",
    kenmerkenValue: "akkerbouwWaarde",
  },
  {
    type: "snijmaisland",
    key: "snijmaisOppervlakte",
    kenmerkenValue: "snijmaisWaarde",
  },
];

type toestandType = {
  [key: string]: number | string;
};

type mappedObject = {
  [key: string]: number | string;
};
export const mapToLayout = (fosfaatState, verdelingenState) => {
  return config.map((item) => {
    const fostfaatObject: mappedObject = {};
    const verdelingenObject: mappedObject = {};
    fosfaatState?.forEach(
      (toestand: toestandType) =>
        (fostfaatObject[toestand.fosfaattoestandCategorieId] =
          toestand?.[item.key])
    );
    verdelingenState?.forEach(
      (grondsoort: toestandType) =>
        (verdelingenObject[grondsoort.grondsoortcategorieId] =
          grondsoort[item.type])
    );
    return {
      ...item,
      fosfaat: fostfaatObject,
      grondsoorten: verdelingenObject,
    };
  });
};

export const flattenKoolstofState = (
  mappedStateToLayout: {
    bodemKoolstof: mappedObject;
    type: string;
    key: string;
  }[]
) =>
  mappedStateToLayout.reduce((a, b) => {
    return { ...a, [b.type]: { ...b } };
  }, {});

export const flattenState = (
  mappedStateToLayout: {
    fosfaat: mappedObject;
    grondsoorten: mappedObject;
    type: string;
    key: string;
  }[]
) =>
  mappedStateToLayout.reduce((a, b) => {
    return { ...a, [b.type]: { ...b } };
  }, {});

export const revertMapFromFlattenState = (arealenFosfaat) => {
  const objectEntries: any[] = Object.values(arealenFosfaat);
  // MAP FOSFAAT KLASSES TO FIND VALUES
  const mappedFosfaatValues = fosfaatklasses.map((klasse) => {
    // FIND CORRECT VALUES
    const mappedValues = objectEntries.map((entry) => {
      return { [entry.fosfaatKey]: entry.fosfaat[klasse.id] };
    });
    const reducedObject = mappedValues.reduce((a, b) => ({ ...a, ...b }), {});
    return {
      fosfaattoestandCategorieId: klasse.id,
      omschrijving: klasse.omschrijving,
      ...reducedObject,
    };
  });
  const mappedGrondsoorten = grondsoorten.map((klasse) => {
    // FIND CORRECT VALUES
    const mappedValues = objectEntries.map((entry) => {
      return { [entry.type]: entry.grondsoorten[klasse.id] };
    });
    const reducedObject = mappedValues.reduce((a, b) => ({ ...a, ...b }), {});
    return {
      grondsoortcategorieId: klasse.id,
      omschrijving: klasse.omschrijving,
      ...reducedObject,
    };
  });
  return { mappedFosfaatValues, mappedGrondsoorten };
};
